export async function getIdToken() {
    throw new Error('getIdToken is not available as a tarobase-server top-level auth operation. Use createWalletClient({ keypair }) and call the returned client methods.');
}
//# sourceMappingURL=utils.js.map